<script>
export default {
  name: 'SimpleRadio',
  inheritAttrs: false,
  emits: ['update:modelValue'],
  props: {
    label: { type: String, default: null },
    modelValue: { type: [String, Number, Boolean, Array] },
    value: { type: [String, Number, Boolean] },
    name: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    index: { type: [String, Number], default: '' },
  },
  computed: {
    inputId() {
      return `${this.name || ''}${this.index.toString().length ? '.' + this.index : ''}`
        .toLowerCase()
        .replace(/\W+/gi, '-')
    },
  },
}
</script>

<template lang="pug">
.form-check
  input.form-check-input(
    :disabled="disabled"
    :id="inputId"
    :name="name"
    :value="value"
    v-model="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    type="radio"
  )
  label.form-check-label.pre-line(v-if="label" :for="inputId") {{ label }}
</template>

<style scoped lang="scss">
.form-check-input {
  border-radius: 50% !important;
}
</style>
